module.exports = __webpack_public_path__ + "static/media/research-4.9daf400f.svg";